import {Dispatch, SetStateAction} from 'react';
import {useMutation} from 'react-query';
import {campaignService} from 'src/shared/services/campaigns';

export const useDeleteCampaign = () => {
  return useMutation(async (id: string) => {
    return await campaignService.deleteCampaign(id);
  });
};
